import {RootState} from "../../../../store/reducer/root/RootState";
import * as React from "react";
import {connect} from "react-redux";
import SelectDictionaryItem from "../../../admin/common/select/SelectDictionaryItem";

class SelectLeadCategory extends SelectDictionaryItem {
	onInputChange(value: string) {
		this.props.onInputChange(value);
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.category.categories
	}
}

export default connect(mapStateToProps)(SelectLeadCategory)